import './HomePage.css';
import InstagramFeed from '../../static/redesSociais/InstagramFeed';

function HomePage() {

  /* ─────────────────────────────────────────────
     SEÇÃO 1 – HERO
     Troque o caminho da imagem de fundo aqui:
  ───────────────────────────────────────────── */
    const heroBackground = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), 
                        url(${process.env.PUBLIC_URL}/images/ImagensDeFundo/ImagemFundo3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    };

  /* ─────────────────────────────────────────────
     SEÇÃO 3 – COLEÇÕES
     Troque os caminhos das imagens aqui:
  ───────────────────────────────────────────── */
  const femininaBg = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/Clothing/Feminina/ImagemAbout1.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  const masculinaBg = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/Clothing/Masculina/ImagemAbout9.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  /* ─────────────────────────────────────────────
     Scroll suave até o catálogo
  ───────────────────────────────────────────── */
  const scrollToClothing = () => {
    const section = document.getElementById('clothing-section');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="homepage-wrapper">

      {/* ══════════════════════════════════════════
          SEÇÃO 1 – HERO (100vh)
          Altere título, subtítulo e texto do botão:
      ══════════════════════════════════════════ */}
      <section className="hero-section" style={heroBackground}>
        <div className="hero-content">

          {/* Título principal */}
          <h1 className="hero-title">D.U</h1>

          {/* Subtítulo */}
          <h2 className="hero-subtitle">O básico pode ser poderoso</h2>

          {/* Botão CTA */}
          <button className="hero-btn" onClick={scrollToClothing}>
            EXPLORAR COLEÇÃO
          </button>

        </div>
      </section>


      {/* ══════════════════════════════════════════
          SEÇÃO 2 – INSTAGRAM (100vh)
          Grid 2×2 de posts com header "Siga-nos".
          Altere o href e o @handle se o perfil mudar:
      ══════════════════════════════════════════ */}
      <section className="instagram-section">

        {/* Cabeçalho */}
        <div className="instagram-header">

          {/* Texto "SIGA-NOS" */}
          <div className='instagram-header-text'>
            <span className="instagram-siga">SIGA-NOS</span>
            <span className="instagram-d.u.br">@d.u.br</span>
          </div>

          {/* Link do perfil — troque href e @handle */}
          <a
            className="instagram-handle"
            href="https://www.instagram.com/d.u.br"
            target="_blank"
            rel="noreferrer"
          >
            {/* Ícone SVG do Instagram */}
            <svg
              className="instagram-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.31.975.975 1.247 2.242 1.31 3.608.058 1.266.069 1.646.069 4.849s-.011 3.584-.069 4.85c-.063 1.366-.335 2.633-1.31 3.608-.975.975-2.242 1.247-3.608 1.31-1.266.058-1.646.069-4.85.069s-3.584-.011-4.849-.069c-1.366-.063-2.633-.335-3.608-1.31-.975-.975-1.247-2.242-1.31-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.849c.062-1.366.334-2.633 1.31-3.608C4.518 2.497 5.785 2.225 7.151 2.163 8.416 2.105 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.333.014 7.053.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.053.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.085 1.856.601 3.698 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.333 23.986 8.741 24 12 24s3.668-.014 4.948-.072c1.856-.085 3.698-.601 5.038-1.942 1.341-1.34 1.857-3.182 1.942-5.038C23.986 15.668 24 15.259 24 12s-.014-3.667-.072-4.947c-.085-1.856-.601-3.698-1.942-5.039C20.646.673 18.804.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
            </svg>
            INSTAGRAM
          </a>

        </div>

        {/* Grid 2×2 — InstagramFeed renderiza os 4 posts */}
        <div className="instagram-grid">
          <InstagramFeed />
        </div>

      </section>


      {/* ══════════════════════════════════════════
          SEÇÃO 3 – COLEÇÕES (100vh)
          Esquerda: feminino | Direita: masculino
          Altere títulos, descrições e onClick dos botões:
      ══════════════════════════════════════════ */}
      <section className="colecoes-section">

        {/* ── FEMININO (esquerda) ──────────────── */}
        <div className="colecao-panel colecao-feminina" style={femininaBg}>
          <div className="colecao-overlay" />
          <div className="colecao-content">

            {/* Título */}
            <h2 className="colecao-titulo">Feminino</h2>

            {/* Descrição */}
            <p className="colecao-descricao">Conheça a elegância D.U</p>

            {/* Botão — troque onClick para navegar até a coleção feminina */}
            <button className="colecao-btn" onClick={scrollToClothing}>
              COMPRE AGORA
            </button>

          </div>
        </div>

        {/* ── MASCULINO (direita) ─────────────── */}
        <div className="colecao-panel colecao-masculina" style={masculinaBg}>
          <div className="colecao-overlay" />
          <div className="colecao-content">

            {/* Título */}
            <h2 className="colecao-titulo">Masculino</h2>

            {/* Descrição */}
            <p className="colecao-descricao">Explore o estilo D.U</p>

            {/* Botão — troque onClick para navegar até a coleção masculina */}
            <button className="colecao-btn" onClick={scrollToClothing}>
              COMPRE AGORA
            </button>

          </div>
        </div>

      </section>

    </div>
  );
}

export default HomePage;